module.exports = __webpack_public_path__ + "img/USDT-TRC-logo.eac1f7bb.svg";